import React, { useState } from "react";
import patterns from "../../assets/icons/patterns.svg";
import { useLocation } from "react-router-dom";
import { FaXmark } from "react-icons/fa6";
const donationOptions = [
	{
		amount: 25,
		title: "25",
		description:
			"Provides a referral to a healthcare provider for a patient in need.",
		bgColor: "#F9DFDD",
		borderColor: "#F9DFDD",
	},
	{
		amount: 50,
		title: "50",
		description:
			"Funds a community outreach initiative to inform patients about available healthcare resources",
		bgColor: "#F6FEE8",
		borderColor: "#CBE1A4",
	},
	{
		amount: 100,
		title: "100",
		description:
			"Helps maintain and expand our patient referral system, improving the process for more individuals",
		bgColor: "#F9EFCC",
		borderColor: "#F9EFCC",
	},
	{
		amount: 0,
		title: "Custom Donation",
		description: "Every donation counts, regardless of the amount.",
		bgColor: "#C3F9F4",
		borderColor: "#C3F9F4",
	},
];

const donationType = ["one-time", "monthly", "annual"];

const DonateForm = () => {
	const location = useLocation();
	const [isLoading, setIsLoading] = useState(false);
	const [showDonationModal, setShowDonationModal] = useState(false);
	const [customDonationAmount, setCustomDonationAmount] = useState(0);
	const [selectDonationType, setSelectDonationType] = useState("one-time");
	const [donationAmount, setDonationAmount] = useState(null);
	const [customDonationInput, setCustomDonationInput] = useState(false);

	const handleDonationClick = (amount, title) => {
		setShowDonationModal(true);
		if (title === "Custom Donation") {
			setCustomDonationInput(true);
			setDonationAmount(customDonationAmount);
		} else {
			setCustomDonationInput(false);
			setDonationAmount(amount);
		}
	};

	const handleDonation = async (e) => {
		if (e) e.stopPropagation();
		setIsLoading(true);

		const baseUrl = window.location.origin + "/#" + location.pathname;
		const successUrl = `${baseUrl}/success`;
		const cancelUrl = `${baseUrl}/failed`;

		try {
			const amount = customDonationInput
				? customDonationAmount
				: donationAmount;
			const response = await fetch(
				"https://office.synergycarefoundation.org/api/payment/paypal",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						amount: amount,
						email: "support@marketmasterusa.com",
						type: selectDonationType,
						success_url: successUrl,
						cancel_url: cancelUrl,
					}),
				}
			);

			const data = await response.json();
			if (data?.message === "PayPal payment created") {
				window.open(data?.payment_url); // Open in new tab
			} else {
				throw new Error();
			}
		} catch (error) {
			console.error("Error initiating PayPal payment:", error);
			setIsLoading(false);
		} finally {
			setIsLoading(false);
			setShowDonationModal(false);
		}
	};

	const handleDonationTypeChange = (e) => {
		setSelectDonationType(e.target.value);
	};

	return (
		<>
			<div className='bg-[#F6FEFA] py-16 px-4'>
				<div className='max-w-[1440px] w-[90%] mx-auto flex flex-col items-center'>
					<h2 className='text-4xl md:text-5xl font-semibold text-[#11112D] mb-8 text-center'>
						How Your Donation Makes an Impact
					</h2>
					<p className='pb-6 text-base/6 text-center max-w-3xl'>
						Choose your preferred donation amount and decide whether you would
						like to make a one-time contribution or set up a recurring monthly
						donation. Your donation will directly support the mission of Synergy
						Care Foundation.
					</p>
					<div className='relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8'>
						{donationOptions.map((option, index) => (
							<div
								key={index}
								onClick={() =>
									handleDonationTypeChange({
										target: { value: option.amount || "custom" },
									})
								}
								className={`cursor-pointer px-6 lg:py-10 py-16 rounded-lg border-2`}
								style={{
									backgroundColor: option.bgColor,
									borderColor: option.borderColor,
								}}>
								{option.amount ? (
									<h3 className='text-5xl/[50px] text-center font-medium text-[#11112D] mb-4'>
										${option.amount}
									</h3>
								) : (
									<h3 className='text-5xl/[50px] text-center font-bold text-[#11112D] mb-4'>
										{option.title}
									</h3>
								)}
								<p className='text-[#43474F] text-center lg:text-sm/6 text-base/[30px] tracking-[1%] leading-relaxed'>
									{option.description}
								</p>
								<button
									className='mt-4 mx-auto w-fit flex items-center gap-x-1 text-[#0F713E] text-lg leading-6 cursor-pointer border-2 border-[#0F713E] rounded-[6px]  px-4 py-1 hover:bg-[#0F713E] hover:text-white transition-all duration-500'
									onClick={() =>
										// handleDonationTypeChange({
										// 	target: { value: option.amount || "custom" },
										// })
										handleDonationClick(option.amount, option.title)
									}
									disabled={isLoading === option.amount}>
									{isLoading === option.amount ? "Processing..." : "Donate Now"}
								</button>
							</div>
						))}

						{/* Image positioned outside the entire container */}
						<img
							src={patterns}
							alt='pattern'
							className='absolute bottom-[-75px] left-[-60px] w-20 h-20'
						/>
					</div>
				</div>
			</div>

			{/* Custom Amount Modal */}
			{showDonationModal && (
				<div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[99999] h-screen'>
					<div className='bg-white sm:p-6 p-4 rounded-lg max-w-[431px] w-[90%]'>
						<div className='flex items-center justify-between text-base/6 font-medium border-b border-[#EAECF0] mb-6 pb-2'>
							<p>SynergyCare Foundation</p>
							<button onClick={() => setShowDonationModal(false)}>
								<FaXmark size={20} />
							</button>
						</div>

						{customDonationInput && (
							<div className='mb-2'>
								<h3 className='text-sm/5 text-[#101828] font-bold mb-4'>
									Enter Custom Amount
								</h3>
								<input
									type='number'
									value={customDonationAmount}
									onChange={(e) => setCustomDonationAmount(e.target.value)}
									placeholder='Enter amount'
									className='w-full p-2 border border-gray-300 rounded mb-4'
									min='1'
								/>
							</div>
						)}

						<>
							<h3 className='text-sm/5 text-[#667085] font-bold mb-2'>
								Select Donation Type
							</h3>
							<div className='flex items-center sm:gap-x-8 gap-x-4 mb-10 '>
								{donationType.map((type, index) => (
									<label
										htmlFor={type}
										key={index}
										className='capitalize flex items-center sm:gap-x-2 gap-x-1 sm:text-base/6 text-xs/5'>
										<input
											id={type}
											name='donationType'
											type='checkbox'
											value={type}
											checked={selectDonationType === type}
											onChange={(e) => {
												if (e.target.checked) {
													setSelectDonationType(type);
												} else {
													setSelectDonationType("");
												}
											}}
											className=''
										/>

										{type}
									</label>
								))}
							</div>
						</>

						<button
							type='button'
							disabled={isLoading}
							onClick={() => handleDonation()}
							className='px-4 py-2 bg-[#22E27F] hover:bg-[#22E27F]/50 rounded-[68px] mx-auto w-fit sm:text-base/6 text-sm/5 disabled:cursor-not-allowed disabled:bg-[]'>
							{isLoading ? "Processing..." : "Donate Now"}
						</button>
					</div>
				</div>
			)}
		</>
	);
};

export default DonateForm;
